import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ExperienceSection from './components/ExperienceSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import BarberSection from './components/BarberSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import LocationSection from './components/LocationSection';
import CtaBanner from './components/CtaBanner';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import { baseUrl, getUrl } from '@/lib/url';

const SCHEMA_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BarberShop",
      "@id": `${getUrl('/')}#barbershop`,
      "name": "Barber Studio Luisfer",
      "description": "Barber Studio Luisfer – barbería premium en Barranquilla, Colombia. Cortes de cabello, arreglo de barba y experiencia de lujo. Reserva tu cita hoy. Más de 10 años perfeccionando el arte del corte masculino.",
      "url": baseUrl,
      "telephone": "",
      "image": "https://storage.readdy-site.link/project_files/0d0d1fd6-befb-4f18-9f8b-efee19c55c96/fe9d8cd5-f344-4aec-86a2-924460c8dc34_LOGO-sin-letra.png?v=e571b3f4ddc76f76526cd8e946a6178b",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Calle 27b # 11-47",
        "addressLocality": "Barranquilla",
        "addressRegion": "Atlántico",
        "addressCountry": "CO"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 10.9685,
        "longitude": -74.7813
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
          "opens": "08:30",
          "closes": "12:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
          "opens": "13:30",
          "closes": "18:00"
        }
      ],
      "priceRange": "$$",
      "currenciesAccepted": "COP",
      "paymentAccepted": "Cash, Credit Card",
      "areaServed": {
        "@type": "City",
        "name": "Barranquilla"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios de Barbería",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Corte de Cabello",
              "description": "Corte de precisión personalizado según tu estilo"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Arreglo de Barba",
              "description": "Perfilado y arreglo profesional de barba"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Corte + Barba",
              "description": "Servicio completo de corte y arreglo de barba"
            }
          }
        ]
      }
    },
    {
      "@type": "WebPage",
      "@id": `${getUrl('/')}#webpage`,
      "url": baseUrl,
      "name": "Barber Studio Luisfer | Barranquilla, Colombia",
      "description": "Barber Studio Luisfer – barbería premium en Barranquilla, Colombia. Cortes de cabello, arreglo de barba y experiencia de lujo. Reserva tu cita hoy. Más de 10 años perfeccionando el arte del corte masculino.",
      "isPartOf": { "@id": `${getUrl('/')}#website` },
      "inLanguage": "es-CO"
    },
    {
      "@type": "WebSite",
      "@id": `${getUrl('/')}#website`,
      "url": baseUrl,
      "name": "Barber Studio Luisfer",
      "inLanguage": "es-CO",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${getUrl('/')}?s={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    }
  ]
};

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(SCHEMA_LD);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('schema-home');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-black antialiased" style={{ scrollBehavior: 'smooth' }}>
      <Navbar onBooking={() => setBookingOpen(true)} />
      <main className="pt-20">
        <HeroSection onBooking={() => setBookingOpen(true)} />
        <ExperienceSection />
        <ServicesSection onBooking={() => setBookingOpen(true)} />
        <AboutSection />
        <BarberSection onBooking={() => setBookingOpen(true)} />
        <GallerySection />
        <TestimonialsSection />
        <CtaBanner onBooking={() => setBookingOpen(true)} />
        <LocationSection onBooking={() => setBookingOpen(true)} />
      </main>
      <Footer onBooking={() => setBookingOpen(true)} />
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </div>
  );
}
